export const getScrollPosition = (): number => {
  const position = window.scrollY || document.documentElement.scrollTop

  return Math.round(position)
}
